// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
// import * as Yup from "yup";
// import { Col, Form, Row } from "react-bootstrap";
// import CustomInput from "../../../CustomControls/CustomInput";
// import { post } from "../../../helpers/api_helper";
// import { Spin } from "antd";
// import { v4 as uuidv4 } from "uuid";
// import {
//   successMessage,
//   errorMessage,
//   capitalizeString,
// } from "../CommonFunctions";
// import {
//   POST_InventoryItemStockInsert,
//   POST_InventoryItemStockUpdate,
//   POST_GetInventoryItemStockDetailByID,
//   POST_GetInventoryItemsListDLL,
// } from "../../../helpers/url_helper";
// import CustomSelect from "../../../CustomControls/CustomSelect";
// import CustomTextArea from "../../../CustomControls/CustomTextArea";

// const AddInventoryItemStock = () => {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);

//   const { PrimaryIdParam } = useParams();
//   const [itemOptions, setItemsOptions] = useState([]);
//   const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

//   useEffect(() => {
//     getInventoryItemsDDL();
//     if (PrimaryIdParam) {
//       getInventoryItemStockDetailsByID();
//     }
//   }, []);

//   const getInventoryItemStockDetailsByID = () => {
//     setIsLoading(true);
//     post(POST_GetInventoryItemStockDetailByID, {
//       InventoryItemStockIDEncrypted: window.atob(PrimaryIdParam),
//     })
//       .then((response) => {
//         if (response?.IsSuccess) {
//           formik.setValues({
//             ...response,
//             IsDiscontinuedNotEdit: response?.IsConsumable,
//           });
//         }
//         setIsLoading(false);
//       })
//       .catch((error) => {
//         console.log(error);
//         setIsLoading(false);
//       });
//   };

//   const getInventoryItemsDDL = () => {
//     setIsLoading(true);
//     post(POST_GetInventoryItemsListDLL, {
//       CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
//       BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
//     })
//       .then((response) => {
//         if (response?.IsSuccess) {
//           setItemsOptions(
//             response?.List?.map((item) => ({
//               label: item?.ItemName,
//               value: item?.InventoryItemIDEncrypted,
//               IsConsumable: item?.IsConsumable,
//               ConsumptionUnit: item?.ConsumptionUnit,
//               UnitName: item?.UnitName,
//               IsItemStockSerialNumberWise: item?.IsItemStockSerialNumberWise,
//             }))
//           );
//         }
//         setIsLoading(false);
//       })
//       .catch((error) => {
//         console.log(error);
//         setIsLoading(false);
//       });
//   };

//   const validationSchema = Yup.object().shape({
//     InventoryItemIDEncrypted: Yup.string()
//       .trim()
//       .required("Item Name is required field"),
//     //Qty: Yup.number().required("Qty is required field"),
//     Qty: Yup.number().when("PrimaryIdParam", ([PrimaryIdParam], schema) => {
//       if (PrimaryIdParam == "")
//         return Yup.string().required("Qty is required field");
//       return schema;
//     }),
//   });

//   const formik = useFormik({
//     validationSchema,
//     onSubmit: (values, formikHelpers) =>
//       handleValidSubmit(values, formikHelpers),
//     initialValues: {
//       InventoryItemStockIDEncrypted: PrimaryIdParam
//         ? window.atob(PrimaryIdParam)
//         : "",
//       InventoryItemIDEncrypted: "",
//       Qty: "",
//       IsDiscontinued: false,
//       ListOfItem: [],
//       ItemName: "",
//       SerialNumber: "",
//       UnitPrice: "",
//       Remarks: "",
//       IsConsumable: false,
//       ConsumptionUnit: "",
//       UnitName: "",
//       IsDiscontinuedNotEdit: false,
//       IsItemStockSerialNumberWise: false,
//     },
//     validateOnBlur: false,
//   });

//   const {
//     setFieldValue,
//     values: {
//       InventoryItemStockIDEncrypted,
//       ListOfItem,
//       InventoryItemIDEncrypted,
//       ItemName,
//       IsDiscontinued,
//       IsConsumable,
//       UnitName,
//       ConsumptionUnit,
//       IsDiscontinuedNotEdit,
//       IsItemStockSerialNumberWise,
//     },
//   } = formik;

//   const handleValidSubmit = (values) => {
//     if (parseInt(values?.Qty) == 0 || values?.Qty == "") {
//       if (!PrimaryIdParam) {
//         formik.setFieldError("Qty", "Qty is required field");
//         formik.setFieldTouched("Qty", true);
//         return;
//       }
//     }

//     let IsItemValid = false;
//     if (!PrimaryIdParam) {
//       Promise.all(
//         values?.ListOfItem?.filter((x) => x?.IsDelete == false)?.map((test) => {
//           if (!test?.UnitPrice || test?.UnitPrice == 0) {
//             IsItemValid = true;
//           }
//         })
//       );
//     }
//     if (IsItemValid) {
//       formik.setFieldError(
//         "ListOfItem",
//         "Please fill all the above details of Item..."
//       );
//       formik.setFieldTouched("ListOfItem", true);

//       setIsLoading(false);
//       return;
//     }

//     setIsLoading(true);

//     let payload = {
//       InventoryItemIDEncrypted: values?.InventoryItemIDEncrypted,
//       InventoryItemStockIDEncrypted: values?.InventoryItemStockIDEncrypted,
//       Qty: values?.Qty,
//       IsDiscontinued: values?.IsDiscontinued,
//       UnitPrice: values.UnitPrice ? values?.UnitPrice.toString() : "0.00",
//       Remarks: values?.Remarks,
//       Listuddt: PrimaryIdParam
//         ? ""
//         : values?.ListOfItem?.map((x, i) => {
//             return {
//               ...x,
//               UnitPrice: x.UnitPrice ? x?.UnitPrice.toString() : "0.00",
//             };
//           }),
//       CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
//       BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
//       CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
//         ? AuthUser?.ReferenceIDEncrypt
//         : "0",
//       ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
//         ? AuthUser?.ReferenceIDEncrypt
//         : "0",
//     };

//     //console.log("payload", payload);

//     post(
//       PrimaryIdParam
//         ? POST_InventoryItemStockUpdate
//         : POST_InventoryItemStockInsert,
//       payload
//     )
//       .then((response) => {
//         setIsLoading(true);
//         if (response?.IsSuccess) {
//           successMessage(response?.Message);
//           setTimeout(() => {
//             navigate("/inventory-item-stock");
//           }, 1000);
//         } else {
//           errorMessage(response?.Message);
//           setIsLoading(false);
//         }
//         setIsLoading(false);
//       })
//       .catch((error) => {
//         console.log(error);
//         setIsLoading(false);
//       });
//   };

//   const handleChangeQty = (e) => {
//     if (e?.target?.value < 1000) {
//       formik.setFieldValue("Qty", e?.target?.value ?? "");
//       let qty = e?.target?.value ?? 0;
//       //let existingList = formik.values.ListOfItem || [];
//       ////formik.setFieldValue(`ListOfItem`, []);

//       if (IsConsumable) {
//         qty = 1;
//       }

//       if (InventoryItemIDEncrypted) {
//         if (parseInt(qty) > 0) {
//           let newValueList = [];
//           let newAddCount = parseInt(qty);
//           const uniqueNumber = generateUniqueNumber(); // each time different
//           const itemPrefix = ItemName.substring(0, 3).toUpperCase(); // first 4 chars in uppercase

//           for (let index = 0; index < newAddCount; index++) {
//             newValueList.push({
//               InventoryItemIDEncrypted: InventoryItemIDEncrypted,
//               SerialNumber:
//                 `${itemPrefix}` +
//                 `${uniqueNumber}` +
//                 `${(index + 1).toString().padStart(3, "0")}`,
//               UnitPrice: "",
//               Remarks: "",
//               IsDelete: false,
//             });
//           }

//           formik.setFieldValue(`ListOfItem`, [...newValueList]);
//         } else {
//           formik.setFieldValue(`ListOfItem`, []);
//         }
//       }
//     }
//   };

//   const generateUniqueNumber = () => {
//     const now = new Date();

//     const year = now.getFullYear();
//     const month = (now.getMonth() + 1).toString().padStart(2, "0");
//     const day = now.getDate().toString().padStart(2, "0");
//     const hours = now.getHours().toString().padStart(2, "0");
//     const minutes = now.getMinutes().toString().padStart(2, "0");
//     const seconds = now.getSeconds().toString().padStart(2, "0");
//     // const random = Math.floor(Math.random() * 100)
//     //   .toString()
//     //   .padStart(3, "0");

//     //return `${year}${month}${day}${hours}${minutes}${seconds}${random}`; // 16 digits
//     return `${year}${month}${day}${hours}${minutes}${seconds}`; // 16 digits
//   };

//   return (
//     <>
//       <div className="card m-1">
//         <div className="card-body p-1">
//           <Spin
//             size="large"
//             spinning={isLoading}
//             tip={"Loading..."}
//             style={{ position: "fixed" }}
//           >
//             <div className="tbl-caption p-2">
//               <h4 className="heading mb-0">
//                 {PrimaryIdParam ? "Edit" : "Add"} Inventory Item Stock
//               </h4>
//             </div>
//             <hr className="mt-0 mb-1"></hr>
//             <div className="p-2 pt-0">
//               <FormikProvider value={formik}>
//                 <Form onSubmit={formik.handleSubmit}>
//                   <Row>
//                     <Col lg={3}>
//                       <Field
//                         label="Item"
//                         name="InventoryItemIDEncrypted"
//                         placeholder={"Select Item"}
//                         options={itemOptions}
//                         component={CustomSelect}
//                         isClearable={false}
//                         isDisabled={PrimaryIdParam ? true : false}
//                         onChange={(e) => {
//                           formik.setFieldValue("ItemName", e?.label ?? "");
//                           formik.setFieldValue(
//                             "InventoryItemIDEncrypted",
//                             e?.value ?? ""
//                           );
//                           formik.setFieldValue("ListOfItem", []);
//                           formik.setFieldValue("Qty", "");
//                           formik.setFieldValue("IsConsumable", e?.IsConsumable);
//                           formik.setFieldValue(
//                             "IsItemStockSerialNumberWise",
//                             e?.IsItemStockSerialNumberWise
//                           );

//                           formik.setFieldValue("UnitName", e?.UnitName);
//                           formik.setFieldValue(
//                             "ConsumptionUnit",
//                             e?.ConsumptionUnit
//                           );
//                         }}
//                       />
//                     </Col>
//                     {!PrimaryIdParam ? (
//                       <>
//                         <Col lg={3}>
//                           <Field
//                             type="number"
//                             label={`Qty ${
//                               ConsumptionUnit ? "(" + ConsumptionUnit + ")" : ""
//                             }`}
//                             name="Qty"
//                             placeholder={"Enter Qty"}
//                             component={CustomInput}
//                             maxLength={20}
//                             numberTypeWithoutDot={true}
//                             required
//                             onChange={handleChangeQty}
//                             disabled={PrimaryIdParam ? true : false}
//                           />
//                         </Col>
//                       </>
//                     ) : (
//                       ""
//                     )}
//                     {PrimaryIdParam ? (
//                       <>
//                         <Col lg={3}>
//                           <Field
//                             label="Serial Number"
//                             name="SerialNumber"
//                             placeholder={"Enter Serial Number"}
//                             component={CustomInput}
//                             disabled={PrimaryIdParam ? true : false}
//                           />
//                         </Col>
//                         <Col lg={3}>
//                           <div className="mb-2">
//                             <label className="mb-1">Discontinued &nbsp;</label>
//                             <div className="form-control form-control-sm">
//                               <input
//                                 type="checkbox"
//                                 className="form-check-input"
//                                 id={`chkIsDiscontinued`}
//                                 name={`chkIsDiscontinued`}
//                                 checked={IsDiscontinued}
//                                 disabled={IsDiscontinuedNotEdit}
//                                 onChange={(e) => {
//                                   formik.setFieldValue(
//                                     "IsDiscontinued",
//                                     !IsDiscontinued
//                                   );
//                                 }}
//                               />
//                               <label className="mb-1 ms-1 mt-1">
//                                 Discontinued &nbsp;
//                               </label>
//                             </div>
//                           </div>
//                         </Col>
//                         <Col lg={3}>
//                           <Field
//                             label="Unit Price"
//                             type="number"
//                             name={`UnitPrice`}
//                             component={CustomInput}
//                             placeholder={"Unit Price"}
//                           />
//                         </Col>
//                         <Col lg={3}>
//                           <Field
//                             name={"Remarks"}
//                             label={"Remarks"}
//                             placeholder={"Remarks"}
//                             component={CustomTextArea}
//                             rows={4}
//                             maxLength={2000}
//                           />
//                         </Col>
//                       </>
//                     ) : (
//                       ""
//                     )}
//                   </Row>
//                   {!PrimaryIdParam ? (
//                     <>
//                       <hr className="mt-1 mb-2"></hr>
//                       <Row>
//                         <Col lg={8}>
//                           <div className="card-header p-2">
//                             <h4 className="card-title">Item Detail</h4>
//                           </div>
//                           <div className="card-body p-1">
//                             <ErrorMessage
//                               name={"ListOfItem"}
//                               component="div"
//                               className="invalid-feedback animated fadeInUp"
//                               style={{ display: "block" }}
//                             />
//                             <div className="table-responsive active-projects style-1 shorting">
//                               <div
//                                 id="ItemDetail-tbl_wrapper"
//                                 className="dataTables_wrapper table-responsive no-footer "
//                                 style={{ height: "500px", overflowY: "auto" }}
//                               >
//                                 <table
//                                   id="ItemDetail-tbl"
//                                   className="table dataTable no-footer mb-0 "
//                                 >
//                                   <thead className="fixedheader">
//                                     <tr>
//                                       <th width="5%">Sr. No</th>
//                                       <th width="20%">Serial Number</th>
//                                       <th width="20%">Unit Price</th>
//                                       <th
//                                         style={{
//                                           width: "20%",
//                                           textAlign: "left",
//                                         }}
//                                       >
//                                         Remarks
//                                       </th>
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     {ListOfItem?.length > 0 ? (
//                                       ListOfItem?.map((item, indx) => (
//                                         <tr key={indx}>
//                                           <td>{indx + 1}</td>

//                                           <td>{item.SerialNumber}</td>
//                                           <td>
//                                             <Field
//                                               type="number"
//                                               name={`ListOfItem.[${indx}].UnitPrice`}
//                                               component={CustomInput}
//                                               placeholder="Unit Price"
//                                               noMarginBottom={true}
//                                               style={{ width: "250px" }}
//                                             />
//                                           </td>

//                                           <td style={{ textAlign: "left" }}>
//                                             <Field
//                                               name={`ListOfItem[${indx}].Remarks`}
//                                               placeholder={`Remarks`}
//                                               component={CustomTextArea}
//                                               rows={2}
//                                               maxLength={2000}
//                                             />
//                                           </td>
//                                         </tr>
//                                       ))
//                                     ) : (
//                                       <tr>
//                                         <td
//                                           colSpan={8}
//                                           style={{ textAlign: "left" }}
//                                         >
//                                           <div>{"No Record Found..."}</div>
//                                         </td>
//                                       </tr>
//                                     )}
//                                   </tbody>
//                                 </table>
//                               </div>
//                             </div>
//                           </div>
//                         </Col>
//                       </Row>{" "}
//                     </>
//                   ) : (
//                     ""
//                   )}
//                   <hr className="mt-1 mb-2"></hr>
//                   <button type="submit" className="btn btn-primary btn-sm me-2">
//                     <i className="fa-solid fa-floppy-disk"></i> Submit
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-danger btn-sm"
//                     onClick={(e) => {
//                       navigate(-1);
//                     }}
//                   >
//                     <i className="fa fa-cancel"></i> Cancel
//                   </button>
//                 </Form>
//               </FormikProvider>
//             </div>
//           </Spin>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddInventoryItemStock;

import React from "react";

const AddInventoryItemStock = () => {
  return <div></div>;
};

export default AddInventoryItemStock;
